export default __webpack_public_path__ + "static/media/extension.032e2a17.png";